module.exports = __webpack_public_path__ + "static/media/approve.bd919437.svg";